import angular from 'angular';
import _ from 'lodash-es';

export default /* @ngInject */ (
	/** @type {any} */ $scope,
	/** @type {any} */ KformComponents,
) => {
	$scope.customComponent = angular.copy($scope.component);
	$scope.$watch('customComponent', (/** @type {any} */ newComponent) => {
		if (newComponent) {
			// Don't allow a type of a real type.
			newComponent.type = (Object.prototype.hasOwnProperty.call(KformComponents.components, newComponent.type)
				? 'custom' : newComponent.type);

			// Ensure some key settings are set.
			newComponent.key = newComponent.key || newComponent.type;

			newComponent.protected = (Object.prototype.hasOwnProperty.call(newComponent, 'protected')
				? newComponent.protected : false);

			newComponent.persistent = (Object.prototype.hasOwnProperty.call(newComponent, 'persistent')
				? newComponent.persistent : true);

			$scope.$applyAsync(() => {
				$scope.$emit('updateKey', newComponent);
				_.assign($scope.component, newComponent);
			});
		}
	});
}
